function getComponent() {
  if (new Error().stack.split("at ").length > 4) {
    const parts = new Error().stack.split("at ")[4].trim().split(" ");
    if (parts.length > 1) {
      let component = parts[1].split(".vue")[0].split("/").pop();
      component = component.split(".js")[0];
      return component + "::" + parts[0];
    } else {
      if (parts[0].split(".vue").length > 1)
        return parts[0].split(".vue")[0].split("/").pop();
    }
  }
}

function getStyle(color) {
  const style = "border-radius:3px;color:white;padding:2px 5px;background:";
  return style + color;
}

function output(color, params) {
  params.unshift(getStyle(color));
  params.unshift("%c" + getComponent());

  applyToConsole(params);
}

function applyToConsole(params) {
  const Console = console;
  if (import.meta.env.MODE == "development" || localStorage.getItem("debug"))
    Console.log.apply(console, params);
}

export function useConsoleLog(...params) {
  output("#006CA2", params);
}

export function useConsoleWarn(...params) {
  output("#A27800", params);
}

export function useConsoleError(...params) {
  output("#A20C00", params);
}

export function useConsoleTodo(...params) {
  output("#a30098", params);
}

export function useConsoleXhrOut(path, method, ...params) {
  method = method.toUpperCase();

  params.unshift(getStyle("#186b00"), getStyle("#000"));
  params.unshift("%c" + method + "%c" + path);

  applyToConsole(params);
}

export function useConsoleXhrIn(path, ...params) {
  params.unshift(getStyle("#A2009A"), getStyle("#000"));
  params.unshift("%cAPI%c" + path);

  applyToConsole(params);
}

export function useConsoleSseIn(path, ...params) {
  params.unshift(getStyle("#8700A2"), getStyle("#000"));
  params.unshift("%cSSE%c" + path);

  applyToConsole(params);
}

//console.clear();
